<div class="inner-content">
  <form (submit)="submit($event)">
    <lyceo-ui-modal-header
      class="mb-1"
      [text]="text()"
      (closeModal)="close()"
    />
    <ion-datetime
      [formField]="form.date"
      color="primary"
      locale="nl-NL"
      presentation="date"
      size="cover"
      [firstDayOfWeek]="1"
      (ionChange)="change($event)"
    />
  </form>
</div>
